import {
  OPERATOR_FIELD_FILTER_REQUEST,
  OPERATOR_FIELD_FILTER_REQUEST_SUCCESS,
  OPERATOR_FIELD_FILTER_REQUEST_FAILURE,
  OPERATOR_FIELD_FILTER_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const operatorFilterFieldsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case OPERATOR_FIELD_FILTER_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case OPERATOR_FIELD_FILTER_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case OPERATOR_FIELD_FILTER_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case OPERATOR_FIELD_FILTER_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default operatorFilterFieldsReducer;
